import React from "react"
import { StyleSheet } from "react-native"
import { View } from "react-native"
import { theme } from "@common/theme/theme"
import TextM from "@common/components/text/TextM"
import FilledButtonM from "@common/components/button/FilledButtonM"
import { ModalSkeleton } from "../common/modals/ModalSkeleton"
import UncontrolledTextInputM from "../common/components/input/UncontrolledTextInputM"

export const AssessmentNeedsModal = ({
    assessmentNeeds,
    setAssessmentNeeds,
    isVisible,
    onClose,
    user,
    onSubmit,
}) => {
    return (
        <ModalSkeleton
            isVisible={isVisible}
            onClose={onClose}
            title={`Précisions sur les besoins de ${user?.firstname}`}
        >
            <View style={styles.summaryCard}>
                <TextM fontWeight="Bold" style={{ marginBottom: 8 }}>
                    Besoins de {user?.firstname}
                </TextM>
                <UncontrolledTextInputM
                    value={assessmentNeeds || ""}
                    onChangeText={setAssessmentNeeds}
                    placeholder={`Ex: ${user?.firstname} a des difficultés en physique également, il a du mal à se concentrer ...`}
                    multiline
                    numberOfLines={5}
                />
            </View>

            <FilledButtonM
                style={{ marginTop: 14, width: "90%", marginBottom: 5 }}
                label="Choisir le créneau"
                onPress={onSubmit}
                color={theme.colors.success}
            />
        </ModalSkeleton>
    )
}

const styles = StyleSheet.create({
    summaryCard: {
        backgroundColor: theme.colors.white,
        borderRadius: 12,
        borderWidth: 1,
        borderColor: theme.colors.lightMore,
        padding: 12,
        marginBottom: 12,
    },
})
